import { ModuleConstants } from '@hrms/common/constant/modules';
import { ModuleRoutesComponentInterface } from '@hrms/common/routes/types';
import { generateImage } from '@hrms/common/utils/generateImage';
import { ComponentsMap } from './components';
import { RouteConstantsInterface, ScreenNamesInterface } from './types';

export enum RouteConstantEnums {
  INCENTIVE_MANAGEMENT,
  CREATE_INCENTIVE,
  ATTENDANCE_INCENTIVE,
  PERFORMANCE_INCENTIVE,
  INCENTIVE_VIEW,
}

export const RouteConstants: RouteConstantsInterface = {
  INCENTIVE_MANAGEMENT: '/incentive-management',
  CREATE_INCENTIVE: '/incentive-management/incentive',
  ATTENDANCE_INCENTIVE: '/incentive-management/:id/attendance',
  PERFORMANCE_INCENTIVE: '/incentive-management/:id/performance',
  INCENTIVE_VIEW: '/incentive-management/:id',
};

export enum ScreenNameEnums {
  INCENTIVE_MANAGEMENT,
  CREATE_INCENTIVE,
  ATTENDANCE_INCENTIVE,
  PERFORMANCE_INCENTIVE,
  INCENTIVE_VIEW,
}

export const ScreenNames: ScreenNamesInterface = {
  INCENTIVE_MANAGEMENT: 'Incentives',
  CREATE_INCENTIVE: 'New Incentive',
  ATTENDANCE_INCENTIVE: 'Attendance Incentive',
  PERFORMANCE_INCENTIVE: 'Performance Incentive',
  INCENTIVE_VIEW: 'Incentive View',
};

const getIncentiveManagementRoutes: ModuleRoutesComponentInterface = () => {
  return [
    {
      id: ModuleConstants.INCENTIVE_MANAGEMENT,
      route: RouteConstants.INCENTIVE_MANAGEMENT,
      title: ScreenNames.INCENTIVE_MANAGEMENT,
      icon: generateImage({
        noScale: true,
        name: 'users-03',
        alt: 'Incentive Management',
        className: 'w-4 h-4',
      }),
      component: ComponentsMap.INCENTIVE_MANAGEMENT,
      children: [
        {
          id: ModuleConstants.CREATE_INCENTIVE,
          route: RouteConstants.CREATE_INCENTIVE,
          title: ScreenNames.CREATE_INCENTIVE,
          component: ComponentsMap.CREATE_INCENTIVE,
          sidebarVisibility: false,
          children: [
            {
              id: ModuleConstants.CREATE_INCENTIVE,
              route: RouteConstants.ATTENDANCE_INCENTIVE,
              title: ScreenNames.ATTENDANCE_INCENTIVE,
              component: ComponentsMap.ATTENDANCE_INCENTIVE,
            },
            {
              id: ModuleConstants.CREATE_INCENTIVE,
              route: RouteConstants.PERFORMANCE_INCENTIVE,
              title: ScreenNames.PERFORMANCE_INCENTIVE,
              component: ComponentsMap.PERFORMANCE_INCENTIVE,
            },
            {
              id: ModuleConstants.INCENTIVE_VIEW,
              route: RouteConstants.INCENTIVE_VIEW,
              title: ScreenNames.INCENTIVE_VIEW,
              component: ComponentsMap.INCENTIVE_VIEW,
            },
          ],
        },
      ],
    },
  ];
};

export default getIncentiveManagementRoutes;
